module.exports = __webpack_public_path__ + "img/project_2.3dcf22bf.png";